import styled from 'styled-components'

export const Wrap = styled.div<{ $maxwidth?: number }>`
  background-color: ${props => props.theme.color.white};
  padding: 32px;
  border-radius: 16px;
  width: calc(100% - 20px);
  max-width: ${props => props.$maxwidth}px;
  max-height: calc(100% - 20px);
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  @media screen and (max-width: ${props => props.theme.resolution.mdx}) {
    padding: 16px;
  }
`

export const Title = styled.div<{ $titlePosition?: 'right' | 'left' | 'center' }>`
  ${props => props.theme.typography.h3}
  color: ${props => props.theme.color.black};
  margin-bottom: 24px;
  text-align: ${props => props.$titlePosition};
  @media screen and (max-width: ${props => props.theme.resolution.mdx}) {
    ${props => props.theme.typography.h4}
  }
`

export const ButtonWrapper = styled.div<{ $buttonPosition?: 'start' | 'end' | 'center' }>`
  display: flex;
  justify-content: ${props => props.$buttonPosition === 'center' ? 'center' : `flex-${props.$buttonPosition}`};
  gap: 16px;
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px dashed ${props => props.theme.color.linkwater};
  @media screen and (max-width: ${props => props.theme.resolution.mdx}) {
    margin-top: 16px;
    padding-top: 16px;
  }
  @media screen and (max-width: ${props => props.theme.resolution.sm}) {
    flex-wrap: wrap;
    & > * {
      width: 100%;
    }
  }
`
